import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import './style.scss';

type ParagraphProps = DetailedHTMLProps<HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> & {
  children: ReactNode;
  isError?: boolean;
};

const Paragraph = (props: ParagraphProps) => {
  const { children, isError, ...rest } = props;
  return (
    <p className={classNames('paragraph', { 'paragraph--error': isError })} {...rest}>
      {children}
    </p>
  );
};

export default Paragraph;
